import {
  Component,
  OnInit,
  Input,
  ViewChild,
  Output,
  EventEmitter,
} from '@angular/core';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { NgxOtpInputConfig, NgxOtpInputComponent } from 'ngx-otp-input';
import { NotificationService } from 'src/app/shared/errors/notification.service';
import { AccountSettingsService } from '../account-setting.service';
import { ERROR_CODES } from 'src/app/shared/constants/error-codes';
import { transformPhone } from 'src/app/shared/utils/utility.service';
import { StateManagementService } from 'src/app/shared/services/state-management.service';
import { IUser } from 'src/app/user-management/user-management-interfaces';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-otp-verification',
  templateUrl: './otp-verification.component.html',
  styleUrls: ['./otp-verification.component.scss'],
})
export class OTPVerificationformComponent implements OnInit {
  /**
   * all necessary input get values from parent
   */
  readonly LANG_CONST = LANG_CONST;
  @ViewChild('ngxotp') ngxOtp: NgxOtpInputComponent | undefined;
  otpInputConfig: NgxOtpInputConfig = {
    otpLength: 6,
    autofocus: true,
    autoblur: true,
  };
  @Input() newPhoneNumber: string = '';
  @Input() email!: string;
  phonePrefix: string | undefined = '';
  codeType: string = 'update';
  medium: string = 'phone';
  otpValue: string | undefined;
  @Input() enableUpdateBtn!: boolean;
  @Output() enableUpdateBtnChange = new EventEmitter<boolean>();
  @Output() successMessage = new EventEmitter();
  @Input() step: number = 2;
  @Output() stepChange = new EventEmitter<number>();
  @Output() enablePhone = new EventEmitter();
  CONSTANTS = CONSTANTS;
  constructor(
    private accountSettingService: AccountSettingsService,
    private notificationService: NotificationService,
    private stateManagementService: StateManagementService,
    private localizationService: LocalizationService,
    private translate: TranslateService
  ) {}

  /**
   * @description this is #ngOnInit life cycle method
   */
  ngOnInit(): void {
    this.localizationService.setupLocalization();
    if (this.newPhoneNumber) {
      const lastFourDigits = this.newPhoneNumber?.slice(-4);
      this.phonePrefix = CONSTANTS.MASK_SEVEN_STARIEK + lastFourDigits;
    }
    this.sendCode();
  }

  /**
   * @description #sendCode function calls the generateCode API.
   */
  sendCode() {
    this.accountSettingService
      .generateCode(
        transformPhone(this.newPhoneNumber),
        this.codeType,
        this.medium
      )
      .subscribe({
        next: (res: any) => {
          if (res?.generateCode?.success) {
            this.enablePhone.emit(false);
            this.stepChange.emit((this.step = 2));
            this.notificationService.showSuccess(
              this.translate.instant('CODE_HAS_BEEN_SENT_TO_YOUR_PHONE')
            );
          }
        },
        error: (err: Error) => {
          this.stepChange.emit((this.step = 1));
          this.notificationService.showError(err?.message);
        },
      });
  }

  /**
   * @description #handleFillEvent function handles the input value for OTP field.
   * @param { string } value
   */
  handleFillEvent(value: string): void {
    this.otpValue = value;
  }

  /**
   * @description #validateOtp function validates the input value for OTP field and calls the verifyCode API.
   */
  validateOtp(): void {
    if (this.otpValue?.length === 6) {
      this.accountSettingService
        .updatePhone(transformPhone(this.newPhoneNumber), this.otpValue)
        .subscribe({
          next: (res: any) => {
            if (res?.updateUser?.email) {
              this.notificationService.showSuccess(
                this.translate.instant('PHONE_UPDATED')
              );
              const user: IUser = this.stateManagementService.getUser();
              user.phoneNumber = this.newPhoneNumber;
              this.stateManagementService.updateUser(user);
              const rememberMe = this.stateManagementService.getRememberMe();
              if (rememberMe?.state) {
                this.stateManagementService.updateRememberMe({
                  state: false,
                  value: '',
                  type: rememberMe.type,
                });
              }
              this.successMessage.emit();
            }
          },
          error: (err: Error) => {
            if (
              err?.message ===
              this.translate.instant('PHONE_NUMBER_ALREADY_EXISTS')
            ) {
              this.stepChange.emit((this.step = 1));
              this.enablePhone.emit(true);
              this.ngxOtp?.clear();
              this.otpValue = '';
            }
            this.notificationService.showError(err?.message);
            this.ngxOtp?.clear();
            this.otpValue = '';
          },
        });
    }
  }
}
